<template>
  <div class="page__footer">
  <div class="container is-relative">
    <div class="page__footer__info columns is-multiline is-gapless-touch">
      <div class="is-hidden-mobile item item--logo column is-4 is-12-touch pl-0-touch bd-0-touch">
        <img :src="require('@/assets/img/icon-footer-logo.svg')" alt="">
      </div>
      <div class="item item--addr column is-5 is-12-touch pl-0-touch bd-0-touch">
        <p>广东省广州市荔湾区黄沙大道15号御景壹号南岸至尚美术馆二楼</p>
        <p>电话：020-81535882</p>
        <p>邮箱：info@xuqinsong-art.org.cn</p>
      </div>
      <div style="padding-top: 0; padding-bottom: 0" class="item item--share column is-3 is-12-touch pl-0-touch bd-0-touch">
        <div class="is-flex-desktop is-flex-mobile">
          <div class="is-flex is-flex-direction-column is-align-items-center">
            <img :src="require('@/assets/img/xqs_qrcode.jpg')" style="width: 100px; height: 100px" alt="">
            <span class="mt-1" style="font-size: 12px">许钦松个人公众号</span>
          </div>
          <div class="ml-4 is-flex is-flex-direction-column is-align-items-center">
            <img :src="require('@/assets/img/xqs_jjh_qrcode.jpg')" style="width: 100px; height: 100px" alt="">
            <span class="mt-1" style="font-size: 12px">基金会公众号</span>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="page__footer__links columns is-multiline is-flex">
      <div class="column is-4 has-text-left">版权所有 广东省许钦松艺术基金会 <br>
      <a href="http://beian.miit.gov.cn/" style=" color: #949494; ">粤ICP备20017424号-1</a> </div>
      <div class="page__footer__links__nav column is-8 is-flex is-justify-content-flex-end">
        <a class="is-inline-flex is-align-items-center " style="color: #C8A979" href="javascript:;" @click="toTop">回到顶部<i style="width: 20px; height: 20px" class="ml-1" data-feather="chevron-up"></i></a>
      </div>
    </div>
  </div>
</div>

    </div>
</template>
<script>
export default {
    name: 'header_html',
    data () {
        return {
        }
    },
    mounted: function () {
    },
    methods: {
        toTop(){
            document.documentElement.scrollTop = 0;
        },
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/footer_html.vue